import { get, put, post, del } from '@/api/request'

// 分页查询所有动态
export function getCirclePostPage(params) {
  return get('/circle/manage/list', params)
}

// 获取动态详情
export function getCirclePostDetail(id) {
  return get(`/circle/manage/${id}`)
}

// 平台发布动态
export function publishCirclePost(data) {
  return post('/circle/manage/publish', data)
}

// 删除动态
export function deleteCirclePost(id) {
  return del(`/circle/manage/${id}`)
}

// 重新上架动态
export function onlineCirclePost(id) {
  return put(`/circle/manage/${id}/online`)
}

// 设置/取消置顶
export function updateCirclePostTop(id, data) {
  return put(`/circle/manage/${id}/top`, data)
}

// 待审核动态列表
export function getPendingAuditList(params) {
  return get('/circle/audit/pending', params)
}

// 审核通过
export function approveCirclePost(id) {
  return put(`/circle/audit/${id}/approve`)
}

// 审核拒绝
export function rejectCirclePost(id, data) {
  return put(`/circle/audit/${id}/reject`, data)
}

/**
 * 查询可用的官方发布者列表（供发布弹窗快速选择）。
 * @returns {Promise<Array<{id: number, nickname: string, avatarUrl: string, status: number, sort: number}>>} 可用发布者列表
 */
export function getAvailableOfficialPublishers() {
  return get('/circle/manage/publishers/available')
}

/**
 * 查询全部官方发布者列表（含停用，供管理弹窗维护）。
 * @returns {Promise<Array<{id: number, nickname: string, avatarUrl: string, status: number, sort: number}>>} 完整发布者列表
 */
export function getOfficialPublishers() {
  return get('/circle/manage/publishers')
}

/**
 * 新增官方发布者。
 * @param {{nickname: string, avatarUrl: string, sort?: number}} data 发布者信息
 * @returns {Promise<{id: number, nickname: string, avatarUrl: string, status: number, sort: number}>} 创建后的发布者
 */
export function createOfficialPublisher(data) {
  return post('/circle/manage/publishers', data)
}

/**
 * 编辑官方发布者。
 * @param {number|string} id 发布者ID
 * @param {{nickname: string, avatarUrl: string, sort?: number}} data 发布者信息
 * @returns {Promise<{id: number, nickname: string, avatarUrl: string, status: number, sort: number}>} 更新后的发布者
 */
export function updateOfficialPublisher(id, data) {
  return put(`/circle/manage/publishers/${id}`, data)
}

/**
 * 更新官方发布者状态。
 * @param {number|string} id 发布者ID
 * @param {{status: number}} data 状态请求
 * @returns {Promise<void>}
 */
export function updateOfficialPublisherStatus(id, data) {
  return put(`/circle/manage/publishers/${id}/status`, data)
}

/**
 * 删除官方发布者（软删除，不影响历史动态）。
 * @param {number|string} id 发布者ID
 * @returns {Promise<void>}
 */
export function deleteOfficialPublisher(id) {
  return del(`/circle/manage/publishers/${id}`)
}
